import React from "react";
import Header from "../../components/Header/index";
import AuthService from "../../services/AuthService";
import TextInput from "../../components/Form/components/TextInput";
import SelectInput from "../../components/Form/components/SelectInput";
import LoadingSpinner from "../../components/LoadingSpinner";
import MembersApi from "../../services/portal-api/MembersApi";
import swal from "sweetalert";
import withAuth from "../../services/withAuth";

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                q1: "",
                a1: "",
                q2: "",
                a2: "",
                password: "",
                passwordRe: "",
            },
            userName: AuthService.getName() || "",
            questions: [],
            isLoading: false,
            resetFields: true,
            forgotPassword: this.getUserId() == 'forgot' ? true : false,
            forgotPasswordA1: "",
            forgotPasswordA2: "",
            proceedToSecondQuentions: false,
            showResetPasswordTextBox: false,
            newPassword: "",
            usernameReadOnly: false,
            errors: {},
            error: {},
        }
    }

    componentDidMount() {
        document.title = 'Reset Password - DuskPortal';
        document.body.className = '';
        this.fetchSecurityQuestions();
        this.getUserQA();
    }

    fetchSecurityQuestions = () => {
        MembersApi.getQuestions((response) => {
            if (response.success) {
                const questionsArr = response.json.questions.map((question) => ({
                    key: question.id,
                    value: question.question,
                }));
                this.setState({ questions: questionsArr });
            }
        });
    };

    getUserId = () => {
        const url = window.location.href;
        const userId = url.split('/').pop();
        return userId;
    }

    getUserQA = () => {
        if(this.getUserId() != 'forgot') {
            MembersApi.getUserQA((response) => {
                this.setState({
                    data: {
                        q1: response.json.data.first.question,
                        a1: response.json.data.first.answer,
                        q2: response.json.data.second.question,
                        a2: response.json.data.second.answer,
                    }
                })
            }, this.getUserId());
        }
    }

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;
        data[name] = event.target.value;
        this.setState({
            data: data,
        }, () => {
            if((this.state.data.q1 == this.state.data.q2) && !this.state.resetFields) {
                swal("Question 1 and Question 2 can not be same", {
                    icon: "warning",
                    buttons: false,
                    timer: 3000
                });

                this.setState({
                    data: {
                        q1: "",
                        a1: "",
                        q2: "",
                        a2: "",
                    }
                })
            }
        })
    };

    handleSubmitPassword = (event) => {
        event.preventDefault();
        let {password, passwordRe} = this.state.data;
        let passwordValidDefinition = [
            {
                minLength    : 6,
                ErrorMessage : "Your password must be at least six characters long.",
            },
            {
                maxLength    : 50,
                ErrorMessage : "Your password cannot be longer than 50 characters.",
            },
            {
                regex        : /.*\d/,
                ErrorMessage : "Your password must contain at least one digit.",
            },
            {
                regex        : /.*[a-zA-Z]/,
                ErrorMessage : "Your password must contain at least one letter.",
            },
            {
                regex        : /.*[!@#$%^&*() =+_-]/,
                ErrorMessage : "Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.",
            },
        ];

       
        let isvalid = true;
        const errors = this.state.errors;
        delete errors["regex"];
        delete errors["minLength"];
        delete errors["maxLength"];
        delete errors["reConfirm"];

        if (password != passwordRe) {
            errors["reConfirm"] = "The confirmation password does not match or is empty."; 
            isvalid = false;
        }

        for (let i = 0; i < passwordValidDefinition.length; i++) {
            let validator = passwordValidDefinition[i];

            if (validator.hasOwnProperty("regex")) {
                if (password.search(validator.regex) < 0){
                    errors["regex"] = validator.ErrorMessage; 
                    isvalid = false;
                }
            }

            if (validator.hasOwnProperty("minLength")) {
                if (password.length < validator.minLength){
                    errors["minLength"] = validator.ErrorMessage; 
                    isvalid = false;
                }
            }

            if (validator.hasOwnProperty("maxLength")) {
                if (password.length > validator.maxLength) {
                    errors["maxLength"] = validator.ErrorMessage; 
                    isvalid = false;
                }
            }
        }

        this.setState({
            errors: errors,
            
        });

        if(!isvalid){
            window.scrollTo(0, 0);
            return false;
        }

        let params = {
            "password": password,
        }

        if(this.state.showResetPasswordTextBox) {
            params["username"] = this.state.userName;
        }

        MembersApi.resetPassword(params, (response) => {
            if(response.json.success == true) {
                if(this.state.showResetPasswordTextBox) {
                    swal("Password reset successfully", {
                        icon: "success",
                        buttons: false,
                        timer: 3000
                    });
    
                    this.props.history.push("/logout");
                } else {
                    this.setState({ resetFields: false });
                }
                
            } else {
                swal(response.json.message, {
                    icon: "warning",
                    buttons: false,
                    timer: 3000
                });
            }
        });

    }

    handleSubmitQuestion = (event) => {
        event.preventDefault();
        this.setState({ isLoading: true });
        const data = this.state.data;
        const params = {
            "q1": data.q1,
            "a1": data.a1,
            "q2": data.q2,
            "a2": data.a2,
            "userId": this.getUserId()
        }
        MembersApi.updateUserQA(params, (response) => {
            this.setState({ isLoading: false });
            if (response.json.success) {
                swal("Security Questions Updated Successfully", {
                    icon: "success",
                    buttons: false,
                    timer: 3000
                });

                this.props.history.push("/logout");
            } else {
                swal(response.json.message, {
                    icon: "warning",
                    buttons: false,
                    timer: 3000
                });
            }
        });
    }

    handleForgotPasswordInput = (event) => {
        event.preventDefault();
        const { a1, a2 } = this.state.data; 
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;
        data[name] = event.target.value;
        if(name === 'userName') {
            this.setState({ 
                userName: event.target.value 
            }, () => {
                MembersApi.getUserSecurityQuestions((response) => {
                    if(response.json.success) {
                        this.setState({
                            data: {
                                q1: this.state.questions.find(item => item.key === response.json.data.first.question).value,
                                a1: response.json.data.first.answer,
                                q2: this.state.questions.find(item => item.key === response.json.data.second.question).value,
                                a2: response.json.data.second.answer,
                            }
                        });
                    }
                }, this.state.userName);
            });
        }

        if(name == 'forgotPasswordA1') {
            this.setState({ 
                forgotPasswordA1: event.target.value 
            }, () => {
                if(this.state.forgotPasswordA1 == a1) {
                    this.setState({
                        proceedToSecondQuentions: true,
                    });
                }
            });
        }

        if(name == 'forgotPasswordA2') {
            this.setState({ 
                forgotPasswordA2: event.target.value 
            }, () => {
                if(this.state.forgotPasswordA2 == a2) {
                    this.setState({
                        showResetPasswordTextBox: true,
                        usernameReadOnly: true,
                    });
                }
            });
        }

        if(name == 'newPassword') {
            this.setState({ 
                data: {
                    password: event.target.value,
                    passwordRe: event.target.value,
                },
                newPassword: event.target.value  
            });
        }
    }

    onAnswerBlur = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;
        let val = event.target.value;
        if(val.length <= 1){
            errors[name] = "Your answer must be at least 2 characters";
        }
        this.setState({
            data: data,
            errors: errors,
        });
    }

   

    render() {
        const passworderr = [];
        for (const [key, value] of Object.entries(this.state.errors)) {
            passworderr.push(<li key={key}><span>{value}</span></li>);
        }

        return (
            <div>
                <Header isLoggedOut={this.getUserId() == "in" ? false: true} isReset={true} />
                <main className="content" role="main">
                    {!this.state.resetFields && !this.state.forgotPassword &&
                        <div className="container padding--40">
                            <h3 style={{fontStyle:"italic"}} className="padding--40--bot">
                                <u>Hi {this.state.userName}, Please customise the questions below in order for you to reset your password in the future.</u>
                            </h3>
                            <form onSubmit={this.handleSubmitQuestion} className="margin--20--top validate loading--inline padding--20--bot" autoComplete="off">
                                <div className="col gutter--20">
                                    <div className="col">
                                        <SelectInput
                                            name="q1"
                                            label="First Question"
                                            options={this.state.questions}
                                            value={this.state.data.q1}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                    <div className="col">
                                        <TextInput
                                            name="a1"
                                            label="Your Answer"
                                            placeholder=""
                                            value={this.state.data.a1}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                </div>
                                <div className="col gutter--20">
                                    <div className="col">
                                        <SelectInput
                                            name="q2"
                                            label="Second Question"
                                            options={this.state.questions}
                                            value={this.state.data.q2}
                                            onChange={this.handleInput}
                                            required={true}
                                            
                                        />
                                    </div>
                                    <div className="col">
                                        <TextInput
                                            name="a2"
                                            label="Your Answer"
                                            placeholder=""
                                            value={this.state.data.a2}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                </div>
                                <footer className="footer--form clearfix">
                                    <div className="footer--form__left">
                                    </div>
                                    <div className="footer--form__right">
                                        <button type="submit" className="btn btn--large btn--color">Save</button>
                                    </div>
                                </footer>
                                <LoadingSpinner isVisible={this.state.isLoading} />
                            </form>
                        </div>
                    }

                    {this.state.resetFields && !this.state.forgotPassword &&
                        <div className="container padding--40">
                            <h3 style={{fontStyle:"italic"}} className="padding--40--bot">
                                <u>Hi {this.state.userName}, Reset your password here</u>
                            </h3>
                            {passworderr.length > 0 && <ul className="alert alert--outline alert--error margin--40--top">{passworderr}</ul>}
                            <form onSubmit={this.handleSubmitPassword} className="margin--40--top validate loading--inline padding--100--bot" autoComplete="off">
                                <div className="col gutter--20">
                                <div className="col full">
                                    <label htmlFor="password" className="">
                                        <span className="sub-title text--grey">Password</span>
                                        <input
                                            id="password"
                                            name="password"
                                            type="password"
                                            className=""
                                            onChange={this.handleInput}
                                            autoComplete="off"
                                        />
                                    </label>
                                </div>
                                </div>
                                <div className="col gutter--20">
                                    <div className="col full padding--10" style={{backgroundColor:"#efefef",fontSize:15}}>
                                        <ul>
                                            <li><span>Your password must be at least six characters long.</span></li>
                                            <li><span>Your password must contain at least one digit and one letter</span></li>
                                            <li><span>Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col gutter--20">
                                    <div className="col full">
                                        <label htmlFor="password" className="">
                                            <span className="sub-title text--grey">Re-confirm Password</span>
                                            <input
                                                id="re-password"
                                                name="passwordRe"
                                                type="password"
                                                className=""
                                                onChange={this.handleInput}
                                                autoComplete="off"
                                            />
                                        </label>
                                    </div>
                                </div>
                                <footer className="footer--form clearfix">
                                    <div className="footer--form__left">
                                    </div>
                                    <div className="footer--form__right">
                                        <button type="submit" className="btn btn--large btn--color">Save</button>
                                    </div>
                                </footer>
                            </form>
                        </div>
                    }

                    {this.state.forgotPassword &&
                        <div className="container padding--40">
                            <div className="col gutter--20">
                                <div className="col full">
                                    <label htmlFor="userName" className="">
                                        <span className="sub-title text--grey">Enter your username</span>
                                        <input
                                            id="userName"
                                            name="userName"
                                            type="text"
                                            className=""
                                            value={this.state.userName}
                                            onChange={this.handleForgotPasswordInput}
                                            required={true}
                                            readOnly={this.state.usernameReadOnly}
                                        />
                                    </label>
                                </div>
                            </div>

                            {this.state.data.q1 != "" && !this.state.showResetPasswordTextBox &&
                                <div className="col gutter--20">
                                    <div className="col">
                                        {this.state.data.q1}
                                    </div>
                                    <div className="col">
                                        <TextInput
                                            name="forgotPasswordA1"
                                            label="Your Answer"
                                            placeholder=""
                                            value={this.state.forgotPasswordA1}
                                            error={this.state.errors.forgotPasswordA1}
                                            onChange={this.handleForgotPasswordInput}
                                            onBlur={this.onAnswerBlur}
                                            required={true}
                                        />
                                    </div>
                                </div>
                            }
                            {this.state.proceedToSecondQuentions && !this.state.showResetPasswordTextBox &&
                                <div className="col gutter--20">
                                    <div className="col">
                                        {this.state.data.q2}
                                    </div>
                                    <div className="col">
                                        <TextInput
                                            name="forgotPasswordA2"
                                            label="Your Answer"
                                            placeholder=""
                                            value={this.state.forgotPasswordA2}
                                            error={this.state.errors.forgotPasswordA2}
                                            onChange={this.handleForgotPasswordInput}
                                            onBlur={this.onAnswerBlur}
                                            required={true}
                                        />
                                    </div>
                                </div>
                            }
                            {this.state.showResetPasswordTextBox &&
                                <div className="col gutter--20">
                                    {passworderr.length > 0 && <ul className="alert alert--outline alert--error margin--40--top">{passworderr}</ul>}
                                    <div className="col full">
                                        <label htmlFor="resetPassword" className="">
                                            <span className="sub-title text--grey">Enter New Password</span>
                                            <input
                                                id="newPassword"
                                                name="newPassword"
                                                type="text"
                                                className=""
                                                value={this.state.newPassword}
                                                onChange={this.handleForgotPasswordInput}
                                                required={true}
                                            />
                                        </label>
                                    </div>
                                    <div className="col">
                                        <button type="submit" onClick={this.handleSubmitPassword} className="btn btn--large btn--color">Save</button>
                                    </div>
                                </div>                        
                            }
                        </div>
                    }
                </main>
            </div>
        );
    }
}

export default ResetPassword;